<section id="vitality-planning">
  @if (centerChoices(); as centerChoices) {
    <div class="lg:flex lg:gap-4">
      <div appAutoClose="always" class="relative mt-2 basis-1/2">
        <button [disabled]="loading()"
                aria-labelledby="centerChoice"
                class="bg-gray-100 py-5 px-4 pr-10 md:px-7 disabled:bg-gray-200 hover:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none"
                type="button">
            <span class="flex items-center">
              <div class="w-12">
              <img alt="{{'caliceoLocation' | translate}}" class="h-9 w-9 flex-shrink-0 m-auto" height="60" ngSrc="assets/icons/gray/location.svg"
                   width="60">
              </div>
                <span
                  class="truncate text-gray-500 font-semibold text-lg ml-4 md:ml-6">
                  <p class="font-semibold truncate text-xs"
                     id="centerChoice">{{ 'caliceoCenterChoice' | translate }}</p>
                  {{ selectedCenter()?.name }}
                </span>
            </span>
          <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
                     <img alt="" class="h-4 w-4" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
            </span>
        </button>
        <ul
          class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
          role="listbox" tabindex="-1">

          @for (center of centerChoices; track center.id) {
            <li (click)="selectCenter(center)"
                (keyup.enter)="emulateClick($event)"
                [attr.aria-selected]="selectedCenter()?.id === center.id"
                class="text-gray-900 hover:bg-gray-100 relative select-none py-4 px-3 md:px-5 cursor-pointer"
                role="option"
                tabindex="0">
              <div class="flex items-center">
                <span [ngClass]="selectedCenter()?.id === center.id ? 'font-semibold' : 'font-normal'"
                      class="text-lg text-gray-500 ml-3 block truncate">
                  {{ center.name }} @if (center.city; as city) {
                  - {{ city }}
                }
                </span>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  }
  <div class="flex flex-col lg:flex-row gap-4 md:gap-8 mt-8 relative">
    @if (selectedCenter(); as center) {
      <div class="grow rounded-lg h-[70vh] border border-gray-300 overflow-scroll">
        <app-planning (eventClicked)="handleEventClicked($event)" [events]="planning()"
                      [loading]="loading()"></app-planning>
      </div>
    }
    @if (selectedSeance(); as seance) {
      <div
        class="rounded-lg shadow-2xl p-8 bg-white absolute left-0 right-0 top-0 bottom-0 m-auto max-h-96 max-w-96 flex flex-col">
        <div class="flex flex-row place-content-between">
          <h1 class="font-semibold text-xl leading-tight uppercase">
            {{ 'bookingVitality' | translate }}</h1>
          <button (click)="selectedSeance.set(null)" class="text-xl font-bold">x</button>
        </div>
        <h2 class="font-semibold text-lg leading-tight">
          {{ seance.course.label }}
        </h2>
        <span class="text-lg leading-tight">{{ seance.date | date }} {{ seance.start }} - {{ seance.end }}</span>
        <div>
          @if (seance.participating === 'yes') {
            {{ 'participating' | translate }}
          } @else if (seance.participating === 'waiting') {
            {{ 'waiting' | translate }}
          } @else if (!seance.remainingCapacity && !seance.remainingWaitingCapacity) {
            {{ 'full' | translate }}
          } @else if (seance.remainingCapacity) {
            {{ 'remainingCapacity' | translate:{ remaining: seance.remainingCapacity.toString() } }}
          } @else {
            {{ 'remainingWaitingCapacity' | translate:{ remaining: seance.remainingWaitingCapacity.toString() } }}
            <div class="w-full">
              <label class="text-gray-500 text-sm" for="toggleHours">
                {{ 'waitToggleHoursLabel.1' | translate }}
              </label>
              <select [formControl]="toggleHours" autocomplete="toggleHours" class="appearance-none text-gray-700 border border-gray-200 rounded-lg py-2 px-2 pr-6 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="toggleHours"
                      name="toggleHours">
                <option [value]="6">6h</option>
                <option [value]="12">12h</option>
                <option [value]="24">24h</option>
                <option [value]="48">48h</option>
              </select>
              <label class="text-gray-500 text-sm" for="toggleHours">
                {{ 'waitToggleHoursLabel.2' | translate }}
              </label>
            </div>
          }
        </div>
        @if (seance.participating === 'no') {
          @if (seance.remainingCapacity) {
            <p
              class="shrink overflow-auto text-xs leading-tight whitespace-pre-line">{{ 'disclaimerVitality' | translate }}</p>
            <button [appProgressClick]="participate" appHoverGradient class="big-btn py-4 text-md">
              {{ 'validate' | translate }}
            </button>
          } @else if (seance.remainingWaitingCapacity) {
            <button [appProgressClick]="wait" appHoverGradient class="big-btn py-4 text-md">
              {{ 'validateWaiting' | translate }}
            </button>
          } @else {
            <button appHoverGradient class="big-btn py-4 text-md" disabled>
              {{ 'full' | translate }}
            </button>
          }
        } @else if (seance.participating === 'waiting') {
          <button [appProgressClick]="cancelWait" appHoverGradient class="big-btn py-4 text-md">
            {{ 'cancelWait' | translate }}
          </button>
        } @else {
          <button [appProgressClick]="cancel" appHoverGradient class="big-btn py-4 text-md">
            {{ 'cancel' | translate }}
          </button>
        }
      </div>
    }
  </div>
</section>
